import React from 'react';
import { connect } from 'react-redux';

import get from 'lodash.get';

import ColoredButton from '../../../components/common/coloredButton';
import CurrencyFormatter from '../../../components/common/currencyFormatter';

import { donationRecurringFrequency, donationRecurringFrequencyAbbreviate } from '../../../constants/recurring';
import { donationPaymentType } from '../../../constants/donationTypeOptions';
import { loadingStatus } from '../../../constants/loading';

class DonateButtonContainer extends React.Component {
    isInProgress = () => {
        return this.props.paymentInProgress === loadingStatus.IS_LOADING;
    }

    isLoading = () => {
        return this.isInProgress() || this.props.fetchingFeeInProgress;
    }

    isDisabled() {
        let isValid = true;

        for (var prop in this.props.tabsValidation) {
            isValid = isValid && this.props.tabsValidation[prop];
        }

        return this.isInProgress() || (this.props.paymentType !== donationPaymentType.pledge.value && !this.props.cardComplete) || this.props.disabled || !isValid;
    }

    render() {
        const isLoading = this.isLoading();
        const isDisabled = this.isDisabled();
        const frequency = donationRecurringFrequency.monthly;

        return (
            <ColoredButton
                fluid
                primary
                loading={isLoading}
                disabled={isDisabled}
                className="action donate-button">
                Donate {this.props.currency} <CurrencyFormatter>{this.props.amount}</CurrencyFormatter> {this.props.isRecurring ? `/ ${donationRecurringFrequencyAbbreviate[frequency]}` : ''}
            </ColoredButton>
        )
    }
}

const mapState = (state) => {
    const paymentType = get(state.donation, 'paymentType');
    const amount = paymentType === donationPaymentType.pledge.value ? get(state, 'donation.amount') : get(state, 'donation.paymentRequestAmount');

    return {
        amount: amount,
        paymentInProgress: get(state, 'donation.paymentInProgress'),
        fetchingFeeInProgress: get(state, 'donation.fetchingFeeInProgress'),
        cardComplete: get(state, 'donation.cardComplete'),
        currency: get(state, 'page.campaign.organization.currency'),
        tabsValidation: get(state, 'donation.tabsValidation'),
        isUserAgreedTerms: get(state, 'donation.isUserAgreedTerms'),
        isArchived: get(state, 'page.campaign.isArchived'),
        isRecurring: get(state, 'donation.subscription.enabled'),
        paymentType: paymentType
    }
}

const DonateButton = connect(mapState)(DonateButtonContainer);
export default DonateButton;
